import { notification } from 'antd'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditTablePayload } from '@app-store/slices/table/edit'

interface TaskAction extends Action {
    payload: IEditTablePayload
}

const { onRequest, onSuccess, onFailure } = rootActions.table.edit

function* editTableSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.patch(`/meeting/table/${payload.tableId}`, payload.data)
        if (response.success) {
            yield put(onSuccess({ response: response.result, tableId: payload.tableId }))
            if (payload?.sagaCB) {
                payload.sagaCB.onSuccess()
            }
            notification.success({
                message: 'Table edited successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure({ error, tableId: payload.tableId }))
    }
}

function* editTableSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editTableSagaTask)
}

export default editTableSaga
